import { forwardRef } from "react";
import ChevronIcon from "../../assets/icons/ChevronIcon";
import Dropdown from 'react-bootstrap/Dropdown';
import { Trans as T } from 'react-i18next';

import { ReactComponent as CheckMarkIcon } from "../../assets/icons_svg/check-mark-outline.svg";
import { ReactComponent as ArchiveIcon } from "../../assets/icons_svg/archive.svg";

import './CategoryStatusDropdown.scss';

export default function CategoryStatusDropdown({ category, onToggleArchive }) {
  return (
    <Dropdown className='__category-status-dropdown'>
      <Dropdown.Toggle as={CategoryStatusToggle} className='status-toggle'>
        <div className="toggle-overflow">
          <div className='label'>
            { category.archived
            ? <div className="label-archived"><ArchiveIcon /><span><T i18nKey='archived-f'>Active</T></span></div>
            : <div className="label-active"><CheckMarkIcon /><span><T i18nKey='active-f'>Archived</T></span></div>
            }
          </div>
          <ChevronIcon className='chevron' />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item as='button' onClick={category.archived ? onToggleArchive : null}><T i18nKey='active-f'>Active</T></Dropdown.Item>
        <Dropdown.Item as='button' onClick={category.archived ? null : onToggleArchive }><T i18nKey='archived-f'>Archived</T></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );  
}

const CategoryStatusToggle = forwardRef(({ children, onClick, ...props }, ref) => (
  <button onClick={onClick} ref={ref} {...props}>
    { children }
  </button>
));
